module.exports = __webpack_public_path__ + "img/bg1.e98ad0fe.png";